import type { SchemaViewerFieldTextProps } from "./schema-viewer-field-text.type";

import { Input } from "antd";

export const SchemaViewerFieldText = ({
  schema,
  disabled,
  ...formItemProps
}: SchemaViewerFieldTextProps) => {
  const { placeholder, readOnly } = schema;

  return (
    <Input
      data-testid="inputText"
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      {...formItemProps}
    />
  );
};
